import { extractGraphQLErrorInfo } from "@/lib/extract-graphql-error-info";
import { ACCOUNT_NOT_FOUND_MESSAGE_PREFIX } from "@ark/shared";

type LoginMessageKey = "login.invalidCredentials" | "login.serverUnavailable" | "login.genericError";

// graphql-request v7 wraps a fetch TypeError ("Failed to fetch") in a ContextualError,
// keeping the original as .cause.
const isRequestFailure = (error: unknown): boolean =>
  error instanceof TypeError || (error instanceof Error && (error as { cause?: unknown }).cause instanceof TypeError);

export function resolveLoginErrorKey(error: unknown): LoginMessageKey {
  if (isRequestFailure(error)) {
    return "login.serverUnavailable";
  }
  if (extractGraphQLErrorInfo(error).userMessage.includes(ACCOUNT_NOT_FOUND_MESSAGE_PREFIX)) {
    return "login.invalidCredentials";
  }
  return "login.genericError";
}
